export default "__VITE_ASSET__f9f3b4d0__"